import { render, staticRenderFns } from "./CartDrawer.vue?vue&type=template&id=0f4c808d&scoped=true&"
import script from "./CartDrawer.vue?vue&type=script&lang=js&"
export * from "./CartDrawer.vue?vue&type=script&lang=js&"
import style0 from "./CartDrawer.vue?vue&type=style&index=0&id=0f4c808d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4c808d",
  null
  
)

export default component.exports